import Shader from '../../shader'
import {simpleShader, clamp} from '../../util'
import * as store from '../../store'

/**
 * @filter         Vignette
 * @description    Adds a simulated lens edge darkening effect.
 * @param size     0 to 1 (0 for center of frame, 1 for edge of frame)
 * @param amount   0 to 1 (0 for no effect, 1 for maximum lens darkening)
 */
export default function(size, amount) {
  var gl = store.get('gl')
  gl.vignette = gl.vignette || new Shader(null, '\
    uniform sampler2D texture;\
    uniform float size;\
    uniform float amount;\
    varying vec2 texCoord;\
    void main() {\
      vec4 color = texture2D(texture, texCoord);\
      \
      float dist = distance(texCoord, vec2(0.5, 0.5));\
      color.rgb *= smoothstep(0.8, size * 0.799, dist * (amount + size));\
      \
      gl_FragColor = color;\
    }\
  ');

  simpleShader.call(this, gl.vignette, {
    size: clamp(0, size, 1),
    amount: clamp(0, amount, 1)
  });

  return this;
}



// WEBPACK FOOTER //
// ./src/filters/adjust/vignette.js